import styled from "styled-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledOnboardingInfoPopupHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledOnboardingInfoPopupFooter = styled(Flex)`
    padding: 8px 16px 16px 16px;
`;

export const StyledOnboardingInfoPopupContentWrapper = styled(Flex)`
    padding: 0 24px;
`;

export const StyledOnboardingInfoImage = styled.img`
    width: 208px;
    height: 160px;
`;

export const StyledOnboardingInfoList = styled.ul`
    list-style-type: disc;
    margin-bottom: 0;
`;
